<template>
  <div>
    <h2 :class="$style.h2TextProp">Measurement Tool</h2>
    <p :class="$style.bodyTextProp">
      We value your privacy and don't store images
    </p>
    <SwitchCm />
    <div :class="$style.row">
      <div :class="$style.col">
        <b :class="$style.subHeading">Front Picture</b>
        <Form
          :value="canvas1"
          :image="canvas1Image"
          @input="setCanvas1"
          @image="setCanvas1Image"
        />
      </div>
      <div :class="$style.col">
        <b :class="$style.subHeading">Side Picture</b>
        <Form
          :value="canvas2"
          :image="canvas2Image"
          @input="setCanvas2"
          @image="setCanvas2Image"
        />
      </div>
    </div>
    <div :class="$style.row">
      <div :class="$style.col">
        <div v-if="!this.isCm">
          <label :class="$style.labelStyle">Height(in):</label>
          <input
            :class="$style.input"
            type="text"
            :value="canvasInput.input1"
            placeholder="i.e.64"
            @input="
              setCanvasInput({ ...canvasInput, input1: $event.target.value })
            "
          />
        </div>
        <div v-if="this.isCm">
          <label :class="$style.labelStyle">Height(cm):</label>
          <input
            :class="$style.input"
            type="text"
            :value="canvasInput.input1"
            placeholder="i.e. 161"
            @input="
              setCanvasInput({ ...canvasInput, input1: $event.target.value })
            "
          />
        </div>
        <div v-if="!this.isCm">
          <label :class="$style.labelStyle">Weight(lb):</label>
          <input
            :class="$style.input"
            type="text"
            :value="canvasInput.input2"
            placeholder="lb"
            @input="
              setCanvasInput({ ...canvasInput, input2: $event.target.value })
            "
          />
        </div>
        <div v-if="this.isCm">
          <label :class="$style.labelStyle">Weight(kg):</label>
          <input
            :class="$style.input"
            type="text"
            :value="canvasInput.input2"
            placeholder="kg"
            @input="
              setCanvasInput({ ...canvasInput, input2: $event.target.value })
            "
          />
        </div>
      </div>
      <div :class="$style.col">
        <div>
          <label :class="$style.labelStyle">Chest:</label>
          <input
            :class="[$style.input, $style.output]"
            type="text"
            disabled
            :value="canvasOutput.output1"
          />
        </div>
        <div>
          <label :class="$style.labelStyle">Waist:</label>
          <input
            :class="[$style.input, $style.output]"
            type="text"
            disabled
            :value="canvasOutput.output2"
          />
        </div>
      </div>
      <div :class="$style.row">
        <div :class="$style.col">
          <button :class="$style.btn" @click="submit">Submit</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Form from "./Form.vue";
import SwitchCm from "@/components/lib/SwitchCm";

import { mapState, mapMutations, mapActions } from "vuex";

export default {
  computed: mapState([
    "isCm",
    "canvasInput",
    "canvasOutput",
    "canvas1",
    "canvas2",
    "canvas1Image",
    "canvas2Image",
  ]),
  components: {
    Form,
    SwitchCm,
  },
  methods: {
    ...mapActions(["submitCanvasInput"]),
    ...mapMutations([
      "setCanvasInput",
      "setCanvasOutput",
      "setCanvas1",
      "setCanvas2",
      "setCanvas1Image",
      "setCanvas2Image",
    ]),
    submit() {
      this.submitCanvasInput();
      this.$gtag.event("submit-cwh-measurements", {
        event_category: "analysis",
        event_label: "submit-click",
        value: 1,
      });
    },
  },
};
</script>

<style lang="scss" module>
.row {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.col {
  width: 45%;
  padding: 15px;
}

.input {
  padding: 10px;
  margin: 10px;
  padding: 10px !important;
  margin: 10px !important;
}

.output {
  color: red;
  font-weight: 900;
}

.labelStyle {
  color: black;
  font-size: 12px;
  font-weight: 900;
}

.btn {
  padding: 8px 20px;
  cursor: pointer;
  border-radius: 5px;
  background-color: #000;
  color: #fff;
  border: 0;
}
.instructionsButton {
  font-size: 17px;
  font-weight: bold;
  text-decoration: underline;
  display: flex;
  align-content: flex-start;
  cursor: pointer;
  color: rgb(0, 0, 0);
  transition: 0.2s;
  padding: 15px;
}
.textProp {
  color: gray;
}
.h2TextProp {
  margin-bottom: 0.5px;
  color: black;
}

.subHeading {
  font-size: 20px;
  color: black;
}
.bodyTextProp {
  text-align: center;
  margin-bottom: 10px;
  color: gray;
}
</style>
